import type { Dispatch } from '@reduxjs/toolkit'

import { invalidateGraphData } from './api/cache-coherence/graph-data-invalidation'
import { setOntologySite } from './api/core'

export type SiteListener = (next: string) => void

/** Same-tab subscribers ('storage' events only fire cross-tab). */
export const siteListeners = new Set<SiteListener>()

export function notifySiteChange(next: string): void {
  for (const listener of siteListeners) listener(next)
}

/**
 * Adopt `siteId` as the active site context. `*` is the explicit all-sites
 * sentinel sent as `X-Ontology-Site`; unlike branch, an empty header would
 * mean "proxy default site" and is not the UI's all-sites state.
 */
export function applySiteSwitch(dispatch: Dispatch, siteId: string): void {
  setOntologySite(siteId)
  notifySiteChange(siteId)
  invalidateGraphData(dispatch)
}
